import { useEffect, useState } from "react";

export default function useFullscreen({ fullscreenElementRef, onExit }) {
  const [inFullscreen, setInFullscreen] = useState(false);

  const openFullscreen = async () => {
    await fullscreenElementRef.current.requestFullscreen();
    setInFullscreen(true);
    // const progressbar = document.querySelector(".progressbar");
    // progressbar && progressbar.classList.remove("hide");
  };

  const exitFullscreen = async () => {
    if (document.fullscreenElement) await document.exitFullscreen();

    setInFullscreen(false);
    onExit();
  };

  const handleFullscreenClose = () => {
    if (!document.fullscreenElement) exitFullscreen();
  };

  useEffect(() => {
    document.addEventListener("fullscreenchange", handleFullscreenClose);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenClose);
    };
  }, []);

  return { openFullscreen, exitFullscreen, inFullscreen };
}
